<script>
   /**************************************************************/
   /* Svelte component for RMSEPlot settings                     */
   /**************************************************************/

   import { Container } from '../controls';

   export let params;
   export let pvoptions;
   export let model;
   export let res;

   $: params = {}
</script>

{#if model && res && params && pvoptions}
<Container label="">
<p class="title">RMSE</p>
</Container>
{/if}

